import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../Inventory/viewInventory.css";
import Customers from "../../api/Customer";

const Customer = props => (
    <tr>
        <td>{props.customer.cName}</td>
        <td>{props.customer.cID}</td>
        <td>{props.customer.email}</td>
        <td>{props.customer.mob}</td>
        <td>{props.customer.password}</td>  
        <td>{props.customer.address}</td>  
        <td>{props.customer.city}</td> 
        <td>{props.customer.company}</td> 
        <td>{props.customer.gst}</td> 
        <td>
            <Link to={"/customer/edit/"+props.customer._id}><i className='bx bx-edit-alt'></i></Link> | <span onClick={() => {props.deleteCustomer(props.customer._id) }} ><i className='bx bx-trash'></i></span>
        </td>
    </tr>
)

class viewCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customers: []
        }
        this.deleteCustomer = this.deleteCustomer.bind(this);
    }

    componentDidMount() {
        Customers.get('/get-customers')
            .then(res => {
                this.setState({ customers: res.data })
            })
            .catch(error => console.log(error));
    }

    deleteCustomer(id) {
        Customers.delete('/delete-customer/' +id)
            .then(res => console.log(res.data));

        this.setState({ customers: this.state.customers.filter(el => el._id !== id)})
    }

    customersList() {
        return this.state.customers.map(currentcustomer => {
            return <Customer customer={currentcustomer} deleteCustomer={this.deleteCustomer} key={currentcustomer._id} />
        })
    }

    render() { 
        return ( 
            <div className='FideologyActivities'>
                <h3 className='fidoh3'>View Customer</h3>
            <div className="fideo">     
                <table className='customer-table'>
                    <thead className="thead-light">
                        <tr>
		                    <th>Name of Customer</th>
		                    <th>Customer ID</th>
                            <th>Email</th>
		                    <th>Mobile</th>
                            <th>Password</th>
                            <th>Billing Address</th>
                            <th>City</th>
                            <th>Company Name</th>
                            <th>GST No.</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.customersList()}
                    </tbody>
                </table>
                <Link to='/add-customer'><div className='add'>Add</div></Link>
            </div>
            </div>
         );
    }
}
 
export default viewCustomer;